import React from 'react';

import { Label } from './label';
import { Nutrient } from './nutrient';

interface INutritionTableRowProps {
  name: string;
  value: number;
  unit: string;
  additionalUnit?: string;
}
export const NutritionTableRow: React.FC<INutritionTableRowProps> = ({
  name,
  value,
  unit,
  additionalUnit,
}) => (
  <Nutrient>
    <Label>{name}</Label>
    <span>
      {value}
      {unit}
      {additionalUnit && <> / {additionalUnit}</>}
    </span>
  </Nutrient>
);
